<template>
  <div id="news">
    <!-- 標題 -->
    <v-title>
      <font-awesome-icon icon="book" />
      事項說明
      <span slot="etext">
        &emsp;Precautions
      </span>
    </v-title>
    <hr />
    <div class="row">
      <!-- web -->
      <div class="col-4 webshow">
        <div id="list-tab" class="list-group" role="tablist">
          <a
            id="list-home-list"
            class="list-group-item list-group-item-action active"
            href="#list-home"
            role="tab"
            data-toggle="list"
            aria-controls="home"
          >
            隱私權條款
          </a>
          <a
            id="list-profile-list"
            class="list-group-item list-group-item-action"
            href="#list-profile"
            role="tab"
            data-toggle="list"
            aria-controls="profile"
          >
            校務研究資訊收集同意書
          </a>
          <a
            id="list-messages-list"
            class="list-group-item list-group-item-action"
            href="#list-messages"
            role="tab"
            data-toggle="list"
            aria-controls="messages"
          >
            網站使用說明
          </a>
          <a
            id="list-settings-list"
            class="list-group-item list-group-item-action"
            href="#list-settings"
            role="tab"
            data-toggle="list"
            aria-controls="settings"
          >
            繳費完成注意事項
          </a>
          <!-- <div class="list-group-item-text pl-2 pr-2 mt-5">
            <div style="font-size: 1.6rem; font-weight: bold; color: #CE0000;">
              ※校內使用者提醒
            </div>
            <div style="font-size: 1.4rem; font-weight: bold; color: #CE0000;">
              1.校內教職員生請直接登入學校帳號、密碼（請勿註冊）<br />
              2.新生請先至學校教務系統更新預設密碼再登入
            </div>
          </div> -->
        </div>
      </div>
      <div class="col-8 webshow">
        <div
          id="nav-tabContent"
          class="tab-content"
          style="overflow-y:scroll;height: 500px;background: white;"
        >
          <div
            id="list-home"
            class="tab-pane fade mt-2 mr-2 ml-2 show active"
            role="tabpanel"
            aria-labelledby="list-home-list"
          >
            <PrivacyText />
          </div>
          <div
            id="list-profile"
            class="tab-pane fade mt-2 mr-2 ml-2"
            role="tabpanel"
            aria-labelledby="list-profile-list"
          >
            <ConsentText />
          </div>
          <div
            id="list-messages"
            class="tab-pane fade mt-2 mr-2 ml-2"
            role="tabpanel"
            aria-labelledby="list-messages-list"
          >
            <UserGuideText />
          </div>
          <div
            id="list-settings"
            class="tab-pane fade mt-2 mr-2 ml-2"
            role="tabpanel"
            aria-labelledby="list-settings-list"
          >
            <PayPrecautionsText />
          </div>
        </div>
      </div>
      <!-- mobile -->
      <div id="accordionExample" class="accordion ml-4 mb-4 mr-4 mobilshow">
        <!-- <div class="list-group-item-text pl-2 pr-2">
          <div style="font-size: 1.2rem; font-weight: bold; color: #CE0000;">
            ※校內使用者提醒
          </div>
          <div style="font-size: 1rem; font-weight: bold; color: #CE0000;" class="mb-3">
            1.校內教職員生請直接登入學校帳號、密碼（請勿註冊）<br />
            2.新生請先至學校教務系統更新預設密碼再登入
          </div>
        </div> -->
        <div class="card">
          <div id="headingOne" class="card-header">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                style="text-decoration: none;"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <font-awesome-icon icon="chevron-circle-down" class="icon-size" />
                <span class="word-bold" style="color: rgb(31, 29, 29); display: contents;">
                  隱私權條款
                </span>
              </button>
            </h2>
          </div>
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <PrivacyText />
            </div>
          </div>
        </div>
        <div class="card">
          <div id="headingTwo" class="card-header">
            <h2 class="mb-0">
              <button
                class="btn btn-link collapsed"
                type="button"
                style="text-decoration: none;"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <font-awesome-icon icon="chevron-circle-down" class="icon-size" />
                <span class="word-bold" style="color: rgb(31, 29, 29); display: contents;">
                  校務研究資訊收集同意書
                </span>
              </button>
            </h2>
          </div>
          <div
            id="collapseTwo"
            class="collapse"
            aria-labelledby="headingTwo"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <ConsentText />
            </div>
          </div>
        </div>
        <div class="card">
          <div id="headingThree" class="card-header">
            <h2 class="mb-0">
              <button
                class="btn btn-link collapsed"
                type="button"
                style="text-decoration: none;"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <font-awesome-icon icon="chevron-circle-down" class="icon-size" />
                <span class="word-bold" style="color: rgb(31, 29, 29); display: contents;">
                  網站使用說明
                </span>
              </button>
            </h2>
          </div>
          <div
            id="collapseThree"
            class="collapse"
            aria-labelledby="headingThree"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <UserGuideText />
            </div>
          </div>
        </div>
        <div class="card">
          <div id="headingFor" class="card-header">
            <h2 class="mb-0">
              <button
                class="btn btn-link collapsed"
                type="button"
                style="text-decoration: none;"
                data-toggle="collapse"
                data-target="#collapseFor"
                aria-expanded="false"
                aria-controls="collapseFor"
              >
                <font-awesome-icon icon="chevron-circle-down" class="icon-size" />
                <span class="word-bold" style="color: rgb(31, 29, 29); display: contents;">
                  繳費完成注意事項
                </span>
              </button>
            </h2>
          </div>
          <div
            id="collapseFor"
            class="collapse"
            aria-labelledby="headingFor"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <PayPrecautionsText />
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
import PrivacyText from '../../components/Article/PrivacyText'
import ConsentText from '../../components/Article/ConsentText'
import UserGuideText from '../../components/Article/UserGuideText'
import PayPrecautionsText from '../../components/Article/PayPrecautions'
export default {
  name: 'news',
  components: {
    PrivacyText,
    ConsentText,
    UserGuideText,
    PayPrecautionsText
  }
}
</script>

<style lang="scss">
@import '../../assets/menu.scss';
.icon-size {
  font-size: 1.6875rem;
}
.list-group-item.active {
  z-index: 2;
  color: #000;
  background-color: rgb(249, 190, 0, 0.62);
  border-color: rgb(249, 190, 0);
}
.webshow {
  display: block;
}
.mobilshow {
  display: none;
}
@media screen and (max-width: 500px) {
  .webshow {
    display: none;
  }
  .mobilshow {
    display: block;
  }
}
</style>
